module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABQUlEQVR4AWOgD6j/r9N3DYiADEzkN3vblVOW369JvF0qBVXvOXP33kN+uw4GAhnISvX6rwAFgUo/bJW85SV3TkARYcO5E3ZABFcq3v5y+pYioNIvJyTvJ8meE1IEqr4gowBVz9n0XbP3JhDxNH8BoqpVva8vKX+7KPG0VgaoCKgUqAGoDagZYQMEJSxc+uCcHtDgV9Olr+iAlALRbX+5j7skgYJA5yE02E45dvKYM1D03RqpG47yEKXXTOWBHgUKXjxpDfQ6yFAIWLkrESj6ab/knTA5iNJLygrPO6WBgs8uaKQtXsDc8AfqCgj4elbiUYHseXGQUiAJZANFPl6R7Vxfz9/yESWUIQBoHsTge7FyQHuABgPtVO6+B1WEqQGoFOju9xtBzgX6BOgfiDRODcAwASq9dcY4av5qoCg+NCgBAHAp6i7s6U9DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CD.png
// module id = 1105
// module chunks = 0